import { mergeMap, map, filter } from 'rxjs/operators';
import { Observable, of, from } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { EpicDependencies } from '../../dependencies.interface';
import { validateDefaultValue, validateEditableImage } from '../../validations';
import {
  VariablesEditorDialogAction,
  createSetDefaultValueValidation,
  OPEN_WITH_EDIT,
  OpenWithEdit,
} from '../../actions';
import { State } from '../../state.interface';

export const setDefaultValueValidationOnOpenWithEdit = (
  actions$: Observable<VariablesEditorDialogAction>,
  state$: StateObservable<State>,
  _dependencies: EpicDependencies,
): Observable<any> =>
  actions$.pipe(
    filter(() => state$.value.useEditableImage),
    ofType(OPEN_WITH_EDIT),
    mergeMap((action: OpenWithEdit) => {
      const state = state$.value;
      if (state.variableConfiguration.type === 'image') {
        return from(
          validateEditableImage(
            action.payload.variableConfiguration.default_value,
            state.translations.validationErrors,
          ),
        );
      }
      return of(
        validateDefaultValue(action.payload.variableConfiguration.default_value, state.translations.validationErrors),
      );
    }),
    map(({ isInvalid, errorMessage }) => createSetDefaultValueValidation(isInvalid, errorMessage)),
  );
